import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const phases = [{
  title: 'DIAGNOSTICAR',
  desc: 'Descubrí exactamente dónde se está escapando tu dinero y cuáles son los errores que están frenando tu crecimiento.'
}, {
  title: 'ORGANIZAR',
  desc: 'Aprendé a ordenar ingresos, gastos y movimientos financieros para tener claridad total sobre tus números.'
}, {
  title: 'MULTIPLICAR',
  desc: 'Conocé estrategias simples para aumentar ganancias y generar nuevas fuentes de ingresos.'
}, {
  title: 'REPROGRAMAR',
  desc: 'Eliminá hábitos financieros que limitan tu crecimiento y desarrollá una mentalidad orientada a resultados.'
}, {
  title: 'PLANIFICAR',
  desc: 'Construí un plan financiero sólido para dejar de improvisar y empezar a crecer con dirección.'
}, {
  title: 'AUTOMATIZAR',
  desc: 'Implementá sistemas que te permitan mantener el control financiero de forma constante.'
}];
export function MethodPhases() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <section className="py-14 md:py-20 bg-background relative" data-id="element-167">
      <div className="container mx-auto px-5 md:px-6" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-8 md:mb-14" data-id="element-169">
          <h2 className="text-2xl sm:text-3xl md:text-6xl mb-3 md:mb-5" data-id="element-170">
            EL MÉTODO DE <span className="text-primary italic" data-id="element-171">6 FASES</span>
          </h2>
          <p className="text-sm md:text-xl text-text-muted" data-id="element-172">
            Un paso a paso estructurado para transformar el caos en control
            absoluto.
          </p>
        </motion.div>

        {/* Mobile: interactive accordion */}
        <div className="md:hidden max-w-md mx-auto space-y-2.5" data-id="element-173">
          {phases.map((phase, i) => {
          const isOpen = openIndex === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className={`rounded-2xl border transition-colors overflow-hidden ${isOpen ? 'bg-surface border-primary/40' : 'bg-surface border-surface-light'}`} data-id="element-174">
                <button type="button" onClick={() => setOpenIndex(isOpen ? -1 : i)} className="w-full px-4 py-3.5 flex items-center gap-3 text-left" data-id="element-175">
                  <div className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center font-serif text-lg transition-all ${isOpen ? 'bg-primary text-text-dark shadow-[0_0_15px_rgba(16,185,129,0.4)]' : 'bg-background border border-primary/30 text-primary-light'}`} data-id="element-176">
                    {i + 1}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-177">
                    <p className="text-[10px] font-bold tracking-widest text-primary uppercase" data-id="element-178">
                      Fase {i + 1}
                    </p>
                    <h4 className="text-base font-serif text-white leading-tight" data-id="element-179">
                      {phase.title}
                    </h4>
                  </div>
                  <ChevronDownIcon className={`w-4 h-4 text-text-muted transition-transform flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-180" />
                </button>
                <AnimatePresence initial={false} data-id="element-181">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-182">
                      <p className="px-4 pb-4 pt-1 text-sm text-text-muted leading-relaxed" data-id="element-183">
                        {phase.desc}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        {/* Desktop: timeline */}
        <div className="hidden md:block max-w-4xl mx-auto relative" data-id="element-184">
          <div className="absolute left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-primary/0 via-primary/30 to-primary/0 -translate-x-1/2" data-id="element-185" />

          <div className="relative" data-id="element-186">
            {phases.map((phase, i) => {
            const isEven = i % 2 === 0;
            return <motion.div key={i} initial={{
              opacity: 0,
              y: 30
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              margin: '-80px'
            }} transition={{
              duration: 0.5
            }} className={`relative flex flex-row items-center h-44 lg:h-48 ${isEven ? 'justify-start' : 'justify-end'}`} data-id="element-187">
                  <div className="absolute left-1/2 -translate-x-1/2 w-12 h-12 rounded-full bg-surface border-2 border-primary flex items-center justify-center z-10 shadow-[0_0_15px_rgba(16,185,129,0.3)]" data-id="element-188">
                    <span className="font-serif text-2xl text-primary-light" data-id="element-189">
                      {i + 1}
                    </span>
                  </div>
                  <div className={`w-[45%] ${isEven ? 'pr-12 text-right' : 'pl-12 text-left'}`} data-id="element-190">
                    <div className="bg-surface p-6 lg:p-8 rounded-3xl border border-surface-light hover:border-primary/40 transition-colors group" data-id="element-191">
                      <h3 className="text-sm font-bold tracking-widest text-primary mb-3 uppercase" data-id="element-192">
                        Fase {i + 1}
                      </h3>
                      <h4 className="text-2xl font-serif mb-4 text-white group-hover:text-primary-light transition-colors" data-id="element-193">
                        {phase.title}
                      </h4>
                      <p className="text-text-muted leading-relaxed" data-id="element-194">
                        {phase.desc}
                      </p>
                    </div>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}